export default "__VITE_ASSET__aa4a60be__"